import { render, staticRenderFns } from "./radio-icon.vue?vue&type=template&id=19afd2da&scoped=true&"
import script from "./radio-icon.vue?vue&type=script&lang=js&"
export * from "./radio-icon.vue?vue&type=script&lang=js&"
import style0 from "./radio-icon.vue?vue&type=style&index=0&id=19afd2da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19afd2da",
  null
  
)

export default component.exports